import React, { useState } from 'react';
import { Send, Phone, Mail, MessageCircle, MapPin, Clock, ShieldCheck, Headphones } from 'lucide-react';
import Button from '../common/Button';
//import Card from '../common/Card';
import Toast from '../common/Toast';

const ContactPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });
    const [showToast, setShowToast] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Contact form submitted:', formData);
        setShowToast(true);
        setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    return (
        <div className="bg-white pt-32 pb-24">
            <div className="container mx-auto px-6">
                {/* Header Section */}
                <div className="max-w-3xl mb-20">
                    <h2 className="text-sm font-bold tracking-[0.2em] text-brand uppercase mb-4">Contactez-nous</h2>
                    <h1 className="text-5xl md:text-6xl font-extrabold text-brand-dark mb-8 leading-tight">
                        Nous sommes là pour donner vie à vos <span className="text-brand italic">idées.</span>
                    </h1>
                    <p className="text-xl text-slate-600 leading-relaxed">
                        Une question sur une commande, un produit spécifique ou besoin d'un conseil d'aménagement ? Notre équipe d'experts est à votre entière disposition.
                    </p>
                </div>

                <div className="flex flex-col lg:flex-row gap-20">
                    {/* Left Side: Contact Form */}
                    <div className="flex-grow lg:w-2/3">
                        <form onSubmit={handleSubmit} className="space-y-8 bg-brand-dark/5 p-8 md:p-12 rounded-[2.5rem] border border-brand-dark/10">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                <div className="space-y-3">
                                    <label className="text-sm font-bold text-brand-dark px-1">Nom Complet</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="Votre nom"
                                        className="w-full h-16 px-6 rounded-2xl bg-white border-2 border-transparent focus:border-brand focus:ring-4 focus:ring-brand/10 transition-all outline-none text-lg"
                                    />
                                </div>
                                <div className="space-y-3">
                                    <label className="text-sm font-bold text-brand-dark px-1">Adresse Email</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="votre@email.com"
                                        className="w-full h-16 px-6 rounded-2xl bg-white border-2 border-transparent focus:border-brand focus:ring-4 focus:ring-brand/10 transition-all outline-none text-lg"
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                <div className="space-y-3">
                                    <label className="text-sm font-bold text-brand-dark px-1">Téléphone (Optionnel)</label>
                                    <input
                                        type="tel"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleInputChange}
                                        placeholder="+221 ..."
                                        className="w-full h-16 px-6 rounded-2xl bg-white border-2 border-transparent focus:border-brand focus:ring-4 focus:ring-brand/10 transition-all outline-none text-lg"
                                    />
                                </div>
                                <div className="space-y-3">
                                    <label className="text-sm font-bold text-brand-dark px-1">Sujet</label>
                                    <select
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleInputChange}
                                        required
                                        className="w-full h-16 px-6 rounded-2xl bg-white border-2 border-transparent focus:border-brand focus:ring-4 focus:ring-brand/10 transition-all outline-none text-lg"
                                    >
                                        <option value="">Sélectionnez un sujet</option>
                                        <option value="Question Produit">Question Produit</option>
                                        <option value="Suivi de Commande">Suivi de Commande</option>
                                        <option value="Conseil Aménagement">Conseil Aménagement</option>
                                        <option value="Partenariat">Partenariat</option>
                                        <option value="Autre">Autre</option>
                                    </select>
                                </div>
                            </div>

                            <div className="space-y-3">
                                <label className="text-sm font-bold text-brand-dark px-1">Votre Message</label>
                                <textarea
                                    name="message"
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    required
                                    rows="6"
                                    placeholder="Comment pouvons-nous vous aider ?"
                                    className="w-full px-6 py-6 rounded-3xl bg-white border-2 border-transparent focus:border-brand focus:ring-4 focus:ring-brand/10 transition-all outline-none text-lg resize-none"
                                ></textarea>
                            </div>

                            <Button variant="primary" type="submit" className="w-full h-16 text-lg shadow-xl shadow-brand-dark/10 group">
                                <Send className="w-5 h-5 mr-3 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                                Envoyer le Message
                            </Button>
                        </form>
                    </div>

                    {/* Right Side: Contact Info & Support */}
                    <div className="lg:w-1/3 space-y-12">
                        {/* Direct Support Cards */}
                        <div className="space-y-6">
                            <h3 className="text-2xl font-bold text-brand-dark pb-4 border-b border-brand-dark/10">Support Direct</h3>

                            <a href="https://wa.me/221338000000" className="flex items-center gap-6 p-6 rounded-3xl bg-white border border-brand-dark/5 shadow-sm hover:shadow-md hover:border-brand-dark/20 transition-all group">
                                <div className="w-14 h-14 bg-green-50 rounded-2xl flex items-center justify-center text-brand group-hover:bg-brand group-hover:text-white transition-colors">
                                    <MessageCircle className="w-7 h-7" />
                                </div>
                                <div className="text-left">
                                    <p className="text-sm font-bold text-brand uppercase tracking-widest">Showroom Guediawaye</p>
                                    <p className="text-lg font-bold text-brand-dark">+221 78 138 74 74</p>
                                </div>
                            </a>

                            <div className="flex items-center gap-6 p-6 rounded-3xl bg-white border border-brand-dark/5 shadow-sm hover:shadow-md hover:border-brand-dark/20 transition-all group">
                                <div className="w-14 h-14 bg-green-50 rounded-2xl flex items-center justify-center text-brand group-hover:bg-brand group-hover:text-white transition-colors">
                                    <Phone className="w-7 h-7" />
                                </div>
                                <div className="text-left">
                                    <p className="text-sm font-bold text-brand uppercase tracking-widest">Showroom Yoff</p>
                                    <p className="text-lg font-bold text-brand-dark">+221 71 140 68 06</p>
                                </div>
                            </div>

                            <div className="flex items-center gap-6 p-6 rounded-3xl bg-white border border-brand-dark/5 shadow-sm hover:shadow-md hover:border-brand-dark/20 transition-all group">
                                <div className="w-14 h-14 bg-green-50 rounded-2xl flex items-center justify-center text-brand group-hover:bg-brand group-hover:text-white transition-colors">
                                    <Mail className="w-7 h-7" />
                                </div>
                                <div className="text-left">
                                    <p className="text-sm font-bold text-brand uppercase tracking-widest">Email</p>
                                    <p className="text-lg font-bold text-brand-dark">contacts@keurfayeameublement.sn</p>
                                </div>
                            </div>
                        </div>

                        {/* Quick Info Grid */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-6">
                            <div className="flex items-start gap-4">
                                <MapPin className="w-6 h-6 text-brand shrink-0" />
                                <div>
                                    <p className="font-bold text-brand-dark mb-1">Notre Showroom</p>
                                    <p className="text-slate-600">Marche bou bess, Guediawaye, Sénégal</p>
                                    <p className="text-slate-600">Cite Apecsy, Yoff, Sénégal</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-4">
                                <Clock className="w-6 h-6 text-brand shrink-0" />
                                <div>
                                    <p className="font-bold text-brand-dark mb-1">Horaires</p>
                                    <p className="text-slate-600">Lun - Sam : 9h - 20h<br />Dim : 10h - 15h</p>
                                </div>
                            </div>
                        </div>

                        {/* Trust Badges */}
                        <div className="p-8 bg-brand-dark rounded-3xl text-white space-y-6">
                            <div className="flex items-center gap-4">
                                <Headphones className="w-10 h-10 text-brand/80" />
                                <p className="font-bold">Assistance 24/7 pour nos clients</p>
                            </div>
                            <div className="flex items-center gap-4">
                                <ShieldCheck className="w-10 h-10 text-brand/80" />
                                <p className="font-bold">Paiements et données sécurisés</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Toast
                message="Message envoyé avec succès ! Notre équipe vous répondra très rapidement."
                isOpen={showToast}
                onClose={() => setShowToast(false)}
            />
        </div>
    );
};

export default ContactPage;

